import * as types from '../types/claimListTypes';

export const fetchClaimList = (claimDetails: any) => ({
    type: types.FETCH_CLAIMS_LIST,
    claimDetails,
});

export const setRowDetails = (payerId: number, providerId: number, hospActionId: number, payerClaimNo: string, providerName: string) => ({
    type: types.SET_ROW_DETAILS,
    payload: {payerId, providerId, hospActionId, payerClaimNo, providerName},
});

export const setClaimDetails = (claimDetails: any) => ({
    type: types.SET_CLAIM_DETAILS,
    claimDetails,
});
